import { skipToken, UseQueryResult, useQuery } from '@tanstack/react-query'

import { getChainConfigEntry } from '@/config/chain'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { MarketRateChartData } from '@/features/sparklend/market-details/data/market-charts/types'

export interface UseSupplyRateHistoricParams {
  chainId: number
  symbol: TokenSymbol
}

export function useSupplyRateHistoric({
  chainId,
  symbol,
}: UseSupplyRateHistoricParams): UseQueryResult<MarketRateChartData> {
  const supplyRateQueryOptions = getChainConfigEntry(chainId).sparkLend?.supplyRateQueryOptions

  return useQuery(
    supplyRateQueryOptions
      ? supplyRateQueryOptions(symbol)
      : {
          queryKey: ['unsupported-supply-rate-query'],
          queryFn: skipToken,
        },
  )
}
